"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var TranslationConsumer_1 = __importDefault(require("../TranslationConsumer/TranslationConsumer"));
var LocalizationProvider_1 = __importDefault(require("../LocalizationProvider/LocalizationProvider"));
var LocalDateRender_1 = __importDefault(require("./LocalDateRender"));
var LocalDate = /** @class */ (function (_super) {
    __extends(LocalDate, _super);
    function LocalDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalDate.prototype.render = function () {
        var _this = this;
        return (React.createElement(LocalizationProvider_1.default, null,
            React.createElement(TranslationConsumer_1.default, null, function (t, lng) { return React.createElement(LocalDateRender_1.default, __assign({}, _this.props, { lng: lng })); })));
    };
    LocalDate.defaultProps = {
        outputFormat: 'L'
    };
    return LocalDate;
}(react_1.Component));
exports.default = LocalDate;
